const deactivated = {
  id: 'deactivated',
  name: 'Deactivated',
  Input: null,
  setInitialContent: () => {
    return {};
  },
  formatContent: () => {
    return {};
  },
  valid: () => true,
  snippet: `{
    "type": "deactivated",
    "content": {}
}`
};

export default deactivated;
